import Vue from 'vue'
import oneMap from './index.vue';
import aMap from './one_map_amap.js'
import bMap from './one_map_bmap.js'
import zMap from './one_map_zmap.js'
let createMap = (param)=>{
    oneMap.install = Vue => Vue.component('oneMap', oneMap);//注册组件
    init(param.config)
    Vue.prototype.$oneMap.config = param.config.initParam
    return oneMap;
   
    // config = param
}   

const init = (param)=>{
    if (!Object.prototype.hasOwnProperty.call(Vue.prototype, '$oneMap')) {
        Vue.prototype.$oneMap = {
            aMap: null,
            bMap: null,
            zMap: null,
            getMap:null
        }
    }
    let options = param.maps;
    if(Array.isArray(options)){
        if(!options.length){
            throw new Error("请传入至少一个地图参数");
        }
        options.forEach(element => {
            if(element.type && element.key){
                loadResources(element,app)
            }else{
                throw new Error("oneMap传入参数确实type或地图key");
            }
        });
    }else{
        throw new Error("参数必须为数组");
    }
}
const loadResources = (option)=>{
    let src, script;
    switch (option.type) {
        case 'amap':
            src = 'https://webapi.amap.com/maps?v=1.4.15&key=' + option.key;
            script = `<script src="${src}"></script>`;
            Vue.prototype.$oneMap.aMap = aMap;
            break;
        case 'bmap':
            src = 'http://api.map.baidu.com/api?v=2.0&ak=' + option.key;
            script = `<script src="${src}"></script>`;
            Vue.prototype.$oneMap.bMap = bMap;
            break;
        case 'zmap':
            src = 'https://webapi.amap.com/maps?v=1.4.15&key=' + option.key;
            script = `<script src="${src}"></script>`;
            Vue.prototype.$oneMap.zMap = zMap;
            break;
        default:
            break;
    }
    console.log(script)
    document.write(script);
}
// const Plugin = {
//     install(app, options) {
//         if (!Object.prototype.hasOwnProperty.call(app.config.globalProperties, '$oneMap')) {
//             app.config.globalProperties.$oneMap = {
//                 aMap: null,
//                 bMap: null,
//                 zMap: null,
//                 getMap:null
//             }
//         }
//         if(Array.isArray(options)){
//             if(!options.length){
//                 throw new Error("请传入至少一个地图参数");
//             }
//             options.forEach(element => {
//                 if(element.type && element.key){
//                     loadResources(element,app)
//                 }else{
//                     throw new Error("oneMap传入参数确实type或地图key");
//                 }
//             });
//         }else{
//             throw new Error("参数必须为数组");
//         }
//         app.component('oneMap', oneMap)
//         app.use(oneMap)
//     },
// };

export {createMap}


// WEBPACK FOOTER //
// ./src/package/index.js